import React, { useState, useEffect } from 'react';
import { ChatComposer, ChatComposerSend } from './chat.styled';
import { Input } from 'antd';
import { Button } from 'components/elements';
import { SendOutlined } from '@ant-design/icons';

/** Same breakpoint as chat layout (`index.tsx` mobile split). */
const CHAT_MOBILE_MAX_WIDTH = 800;

type ComposerProps = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  placeholder?: string;
};

const Composer: React.FC<ComposerProps> = ({
  value,
  onChange,
  onSend,
  placeholder = 'Type a message...',
}) => {
  const [showSendLabel, setShowSendLabel] = useState(
    () => typeof window !== 'undefined' && window.innerWidth > CHAT_MOBILE_MAX_WIDTH,
  );

  useEffect(() => {
    const onResize = () => {
      setShowSendLabel(window.innerWidth > CHAT_MOBILE_MAX_WIDTH);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleKeyDown: React.KeyboardEventHandler<HTMLTextAreaElement> = (e) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <ChatComposer>
      <Input.TextArea
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={3}
      />
      <ChatComposerSend>
        <Button
          type="primary"
          onClick={onSend}
          aria-label={showSendLabel ? undefined : 'Send message'}
        >
          {showSendLabel && <span style={{ marginRight: '0.35em' }}>Send</span>}
          <SendOutlined />
        </Button>
      </ChatComposerSend>
    </ChatComposer>
  );
};

export default Composer;
